export const relatedProductQuery = `
query ExtendedProductsById($productIds: [Int!]) {
  site {
    products(entityIds: $productIds) {
      edges {
        node {
          name
          id
          relatedProducts(hideOutOfStock: true) {
            edges {
              node {
                addToCartUrl
                sku
                entityId
                name
                defaultImage { urlOriginal }
                prices {
                  price { formatted }
                  priceRange { max { formatted } min { formatted }  }
                }               
              }
            }
          }
        }
      }
    }
  }
}
`;

export const productsDetail = `
query ExtendedProductsById($productIds: [Int!]) {
    site {
      products(entityIds: $productIds, first: 50) {
        edges {
          node {
            name
            sku
            entityId
            defaultImage { urlOriginal }
            prices { price { formatted } }
          }
        }
      }
    }
}
`;

export const metaFieldsQuery = `
query ExtendedProductsById($productIds: [Int!]) {
    site {
        products(entityIds: $productIds) {
            edges {
                node {
                    name
                    entityId
                    recommendedProducts: metafields(namespace: "recommended.products", first: 50) {
                        edges { node { key value } }
                    }
                    alternativeProducts: metafields(namespace: "alternative.products", first: 50) {
                        edges { node { key value } }
                    }   
                    crossSellProducts: metafields(namespace: "crosssell.products", first: 50) {
                        edges { node { key value } }
                    }
                }
            }
        }
    }
}
`;
